(function(){
    'use strict';

    /* Filters */

    angular.module('GorillaBoy.filters')
        .filter('getHumanReadableContentType', ['ContentTypeFormatter', function (ContentTypeFormatter) {
            return function (mimeType) {
                return ContentTypeFormatter.toReadableString(mimeType);
            };
        }])

         .filter('humanReadableContentTypeName', ['ContentTypeFormatter', '$translate',
            function (ContentTypeFormatter, $translate) {
            return function (file) {
                 var typeName = '';
                // Determine folder vs single file.
                if (file.VersionMetadata){
                    typeName = ContentTypeFormatter.toReadableString(file.VersionMetadata.ContentType);
                } else {
                    typeName = $translate.instant('FILE_TYPES.FOLDER');
                }

                // TODO: fetch string from Localization Manager
                return typeName;
            };
        }])
        /**
         * The below filter will filter out duplicates from an array.
         */
        .filter('unique', function () {
            //The below arguments are only for explanatory purposes
            return function(arrayElem, isSorted, callback, thisArg) {
                return _.uniq.apply(null, Array.prototype.slice.call(arguments));
            };
        })
        .filter('removeTrailingZeros', [function () {
            return function (storageUsedInGigaBytes) {
                if (storageUsedInGigaBytes) {
                    return storageUsedInGigaBytes.toFixed(2).replace(/\.([^0]+)0+$/,".$1").replace(/\.0+$/,"");
                } else {
                    return 0;
                }
            };
        }])
        .filter('getHumanReadableSize', [function () {
            var lang = window.determinePreferredLanguage().toLowerCase();
            return function (sizeInBytes) {
                if (sizeInBytes < 0 || sizeInBytes === undefined) {
                    return '--';
                }

                if(sizeInBytes === 0) {
                    return "0 B";
                }

                var prefixes = ' KMGTPEZYXWVU';
                var prefixIndex = Math.min(Math.floor(Math.log(sizeInBytes) / Math.log(1024)), 12);
                return (Math.round(sizeInBytes * 100 / Math.pow(1024, prefixIndex)) / 100) + ' ' +
                    prefixes.charAt(prefixIndex).replace(' ', '') + (lang === 'fr' && prefixIndex > 0 ? 'o' : 'B');
            };
        }])
        .filter('getHumanReadableDateTime', ['DateTimeService', function (DateTimeService) {
            return DateTimeService.getHumanReadableDate;
        }])
        .filter('documentViewUrlWithTabName', ['AppConstants', function (AppConstants) {
            /**
             * @ngdoc filter
             * @name documentViewUrlWithTabName
             *
             * @param {string} baseUrl Base url of document.
             * @param {string} viewTypes Type of folder view.
             *
             * @description
             * Based on the viewTypes parameter, return a document url
             * that contains a search parameter that dicatates which right tab to show when
             * the document is viewed or return the original passed-in base url.
             */

            return function (baseUrl, folderViewType) {

                return baseUrl;
            };
        }])
        .filter('encodeURIComponent', function() {
            return function(input) {
                if (input) {
                    return window.encodeURIComponent(input);
                }
                return "";
            };
        });
}());
